/**
 * @file
 * Kit grid/list presentation switch.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const ui = Drupal.berUI;
  const { base } = ui.compose;

  // The grid/list presentation switch.
  ui.viewSwitch = ({
    key = 'view-mode',
    label = Drupal.t('Grid view'),
    icon = 'grid',
    value,
    onChange,
  } = {}) => {
    const api = base(
      components.viewToggle({ key, label, icon, value, onChange }).el,
    );
    ui.emit('viewSwitch', { component: api });
    return api;
  };

  ui.register('viewSwitch', ui.viewSwitch);
})(Drupal);
